<template>
  <div>
    <el-tooltip effect="dark" content="主题" placement="bottom">
      <el-button class="d2-ml-0 d2-mr btn-text can-hover" type="text" @click="dialogVisible = true">
        <d2-icon name="diamond" style="font-size: 16px"/>
      </el-button>
    </el-tooltip>
    <el-dialog title="主题" width="600px" :visible.sync="dialogVisible">
      <zebra-theme-list style="margin-top: -25px;"
                        :themeList="themeList"
                        :themeActiveName="themeActiveName"
                        @d2adminThemeSet="handleSelectTheme"
      />
    </el-dialog>
  </div>
</template>

<script>
import themeList from './components/d2-theme-list/theme-list'
export default {
    name: 'ZebraTheme',
    props: {
        themeList: {
            type: Array
        },
        themeActiveName: {
            type: String
        }
    },
  components: {
    'ZebraThemeList': themeList
  },
  data () {
    return {
      dialogVisible: false
    }
  },
    methods: {
        handleSelectTheme(name) {
            //this.d2adminThemeSet(name)
            this.$emit('d2adminThemeSet',name)
        }
    }
}
</script>
